// src/icons/MagicWand.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function MagicWand({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9 9.99954L1 17.9995L2.5 19.4995L4 20.9995L12 12.9995M9 9.99954L11.2929 7.70665C11.6834 7.31612 12.3166 7.31612 12.7071 7.70665L14.2929 9.29243C14.6834 9.68296 14.6834 10.3161 14.2929 10.7067L12 12.9995M9 9.99954L12 12.9995",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9 2.99951C10.3668 4.36635 10.5 4.49951 10.5 4.49951M10.5 2.99951L9 4.49951",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18 8.99969C20.7337 11.7334 21 11.9997 21 11.9997M21 8.99969L18 11.9997",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.5977 0.999512C16.5971 4.73377 16.4996 5.09759 16.4996 5.09759M19.0977 3.59759L14.9996 2.49951",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        )
      ]
    }
  );
}

export {
  MagicWand
};
